import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { useHistory } from "react-router";

export const register = createAsyncThunk(
  "user/register",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/register`,
        params,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (err) {
      // Handle different types of errors
      if (err.response) {
        // Server responded with error status
        return rejectWithValue(err.response.data);
      } else if (err.request) {
        // Request was made but no response received
        return rejectWithValue({
          message: "Network error - no response from server",
          error: "NETWORK_ERROR",
        });
      } else {
        // Something else happened
        return rejectWithValue({
          message: err.message || "Registration failed",
          error: "UNKNOWN_ERROR",
        });
      }
    }
  }
);

export const login = createAsyncThunk(
  "user/login",
  async (params, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/api/login`,
        params,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
          },
        }
      );
      return response.data;
    } catch (err) {
      // Log the full error for debugging
      console.error("Login error details:", {
        response: err.response,
        request: err.request,
        message: err.message,
        status: err.response?.status,
        data: err.response?.data,
      });

      // Handle different types of errors
      if (err.response) {
        // Server responded with error status
        return rejectWithValue(err.response.data);
      } else if (err.request) {
        // Request was made but no response received
        return rejectWithValue({
          message: "Network error - no response from server",
          error: "NETWORK_ERROR",
        });
      } else {
        // Something else happened
        return rejectWithValue({
          message: err.message || "Login failed",
          error: "UNKNOWN_ERROR",
        });
      }
    }
  }
);

const initialSate = {
  loading: false,
  user: {},
  error: null,
};

export default createSlice({
  name: "user",
  initialState: initialSate,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.error = null;
      localStorage.removeItem("user-info");
    },
  },
  extraReducers: {
    [register.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [register.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.user = payload;
      state.error = null;
      localStorage.setItem("user-info", JSON.stringify(payload));
    },
    [register.rejected]: (state, action) => {
      state.loading = false;

      // Handle structured error objects or fallback to simple message
      if (action.payload && typeof action.payload === "object") {
        state.error =
          action.payload.message ||
          action.payload.error ||
          "Registration failed";
      } else {
        state.error =
          action.payload || action.error?.message || "Registration failed";
      }

      console.error("Registration failed:", action.payload || action.error);
    },
    [login.pending]: (state) => {
      state.loading = true;
      state.error = null;
    },
    [login.fulfilled]: (state, { payload }) => {
      state.loading = false;
      state.user = payload;
      state.error = null;
      //state.user.authenticated = true; removed to fix Cannot create property 'authenticated' on string  error
      localStorage.setItem("user-info", JSON.stringify(payload));
    },
    [login.rejected]: (state, action) => {
      state.loading = false;

      // Handle structured error objects or fallback to simple message
      if (action.payload && typeof action.payload === "object") {
        state.error =
          action.payload.message || action.payload.error || "Login failed";
      } else {
        state.error = action.payload || action.error?.message || "Login failed";
      }

      console.error("Login failed:", action.payload || action.error);
    },
  },
});
